(() => {
 const root = document.documentElement;
 const motion = matchMedia('(prefers-reduced-motion: reduce)');
 function reveal() {
   clearTimeout(window.pageRevealFallback);
   root.classList.remove('page-ready');
   if (motion.matches) { root.classList.remove('page-pending'); return; }
   root.classList.add('page-pending');
   void document.querySelector('.page')?.offsetWidth;
   requestAnimationFrame(() => requestAnimationFrame(() => {
     root.classList.add('page-ready');
     root.classList.remove('page-pending');
   }));
 }
 Promise.race([document.fonts.ready, new Promise(resolve => setTimeout(resolve, 1200))]).then(reveal);
 addEventListener('pageshow', event => { if (event.persisted) reveal(); });
})();
